import { createAction } from '@reduxjs/toolkit';
import { getPayloadCreator } from 'app-components/flux/core/actionHelpers';
import type { QcsSyncResourcesPayload } from 'app-components/flux/core/resourceStoreTypes';

import type { A2aTransfer, A2aTransferProps } from './a2aTransfersTypes';

const errorPayloadCreator = getPayloadCreator<{ id?: string; message?: string }>();
const transfersPayloadCreator = getPayloadCreator<QcsSyncResourcesPayload<A2aTransferProps | A2aTransfer>>();

export const getA2aTransfers = createAction('GET_A2A_TRANSFERS', getPayloadCreator());
export const getA2aTransfersSuccess = createAction('GET_A2A_TRANSFERS_SUCCESS', transfersPayloadCreator);
export const getA2aTransfersFailure = createAction('GET_A2A_TRANSFERS_FAILURE', errorPayloadCreator);

export const cancelA2aTransfer = createAction('CANCEL_A2A_TRANSFER', getPayloadCreator<string>()); // expects id as payload
export const cancelA2aTransferSuccess = createAction('CANCEL_A2A_TRANSFERS_SUCCESS', transfersPayloadCreator);
export const cancelA2aTransferFailure = createAction('CANCEL_A2A_TRANSFERS_FAILURE', errorPayloadCreator);
